import { FormFieldContainer } from '../../Form'
import { Switch } from '../Switch'

import * as styles from './SwitchInput.module.css'

function SwitchInput({ error, ...restProps }) {
  return (
    <FormFieldContainer className={styles.fieldContainer} error={error}>
      <Switch {...restProps} />
    </FormFieldContainer>
  )
}

export default SwitchInput
